import startCase from "lodash/startCase";
import { EmailOutlined, Link, LockRounded, PhoneRounded, } from "@mui/icons-material";
import { formatPhoneNumber } from "../../utils";
import { ObjectStore } from "../../types";
var securedByMessage = function (auth, authCount) {
    if ((auth === null || auth === void 0 ? void 0 : auth.auth_type) === ObjectStore.ShareAuthenticatorType.Email) {
        return "Secured by ".concat(auth.auth_context);
    }
    if ((auth === null || auth === void 0 ? void 0 : auth.auth_type) === ObjectStore.ShareAuthenticatorType.Sms) {
        return "Secured by ".concat(formatPhoneNumber(auth.auth_context));
    }
    if ((auth === null || auth === void 0 ? void 0 : auth.auth_type) === ObjectStore.ShareAuthenticatorType.Password) {
        return "Secured by password";
    }
    return "Secured by ".concat(authCount, " authenticators");
};
export var getShareDisplayName = function (object) {
    var _a, _b;
    if (!object || !(object === null || object === void 0 ? void 0 : object.authenticators))
        return "Share link";
    var authCount = (_b = (_a = object === null || object === void 0 ? void 0 : object.authenticators) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    var identityAuth = authCount === 1 ? object.authenticators[0] : undefined;
    if (object.recipient_email) {
        return "Shared with ".concat(object.recipient_email);
    }
    return securedByMessage(identityAuth, authCount);
};
export var getShareTooltip = function (object) {
    var _a, _b;
    if (!object || !(object === null || object === void 0 ? void 0 : object.authenticators))
        return "Share link";
    var authCount = (_b = (_a = object === null || object === void 0 ? void 0 : object.authenticators) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    var identityAuth = authCount === 1 ? object.authenticators[0] : undefined;
    var type = object.link_type || "download";
    var msg = securedByMessage(identityAuth, authCount);
    return "".concat(startCase(type), ": ").concat(msg);
};
export var getShareDisplayIcon = function (object) {
    var _a, _b;
    if (!object || !(object === null || object === void 0 ? void 0 : object.authenticators))
        return Link;
    var authCount = (_b = (_a = object === null || object === void 0 ? void 0 : object.authenticators) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
    var identityAuth = authCount === 1 ? object.authenticators[0] : undefined;
    if ((identityAuth === null || identityAuth === void 0 ? void 0 : identityAuth.auth_type) === ObjectStore.ShareAuthenticatorType.Email) {
        return EmailOutlined;
    }
    if ((identityAuth === null || identityAuth === void 0 ? void 0 : identityAuth.auth_type) === ObjectStore.ShareAuthenticatorType.Password) {
        return LockRounded;
    }
    if ((identityAuth === null || identityAuth === void 0 ? void 0 : identityAuth.auth_type) === ObjectStore.ShareAuthenticatorType.Sms) {
        return PhoneRounded;
    }
    return Link;
};
export var getDateDisplayName = function (dateString) {
    return new Date(dateString).toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: undefined,
    });
};
